import { Box, Button, Icon, Stack } from "@mui/material";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { EmptyListMessage } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { RootState } from "../../../slices/Store";
import NoteItem from "../../projects/components/NoteItem";
import UpsertNoteDialog from "../../projects/dialogs/UpsertNoteDialog";

// updated
export default function ProjectDetailNotes() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const { openDialog } = useContext(DialogContext);

    const addReminder = () => {
        openDialog(
            <UpsertNoteDialog
                projectHashId={projectDetailState.projectHashId}
            />
        );
    };

    return (
        <Stack spacing={2}>
            <EmptyListMessage
                condition={projectDetailState.notes.length === 0}
                message="یادداشتی برای این پروژه ثبت نشده است"
            />

            {projectDetailState.notes.map((r) => {
                return (
                    <NoteItem
                        key={r.id}
                        projectHashId={projectDetailState.projectHashId}
                        note={r}
                    ></NoteItem>
                );
            })}

            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                    variant="outlined"
                    onClick={addReminder}
                    startIcon={<Icon>add</Icon>}
                >
                    افزودن یادداشت
                </Button>
            </Box>
        </Stack>
    );
}
